/**
 * O que falta ao caso digital (E193.F1 — GUS-259, ADR-0139).
 *
 * Espelha `ArquivoPendente` de `apps/api/types/kit_digital.py` (a paridade é conferida por
 * `tests/unit/test_e193_f1_contrato_web.py`). A régua é do servidor: a conferência do kit grava a
 * lista no caso, e a lista do portal, o acompanhamento, o recibo do envio e o caso da equipe a leem
 * igual. Aqui só se monta a frase de cada item. E216.F2 (GUS-317 item 6): o documento declarado sai
 * pelo nome, sem o hash ("Documento declarado no arquivo de evidências e não enviado: Selfie").
 */
import { ptBR } from '@/i18n/pt-BR';

const t = ptBR.arquivosPendentes;

export type CodigoDoPendente = 'arquivo_de_evidencias' | 'carimbo_do_tempo' | 'documento_declarado';

export interface ArquivoPendenteData {
  codigo: CodigoDoPendente;
  /**
   * O rótulo do `content.json` ("Hash da Selfie") no documento declarado; no carimbo do tempo, de
   * qual CCB ("proposta 29706925"), só com mais de uma no caso (E193.F1.C06).
   */
  rotulo?: string | null;
  /** O SHA-256 declarado; só no documento declarado. */
  sha256?: string | null;
}

/** "61a5…a253": os quatro primeiros e os quatro últimos caracteres do hash. */
export function hashAbreviado(sha256: string): string {
  return sha256.length > 8 ? `${sha256.slice(0, 4)}…${sha256.slice(-4)}` : sha256;
}

/**
 * "Hash da Selfie:" → "Selfie": o nome do documento no rótulo do arquivo de evidências (o pacote
 * 43298429 escreve o rótulo com dois-pontos). A mesma regra de `kit_digital.nome_do_declarado`.
 */
export function nomeDoDeclarado(rotulo: string): string {
  const limpo = rotulo.replace(/\s*:\s*$/, '').trim();
  return limpo.replace(/^hash\s+(?:d[aoe]s?\s+)?/i, '') || limpo;
}

/** A frase sem o nome e o nome, para a lista destacar o documento (E216.F2). */
export function partesDoPendente(pendente: ArquivoPendenteData): { texto: string; nome?: string } {
  if (pendente.codigo !== 'documento_declarado') return { texto: textoDoPendente(pendente) };
  return {
    texto: t.item.documento_declarado.replace('{nome}', '').trimEnd() + ' ',
    nome: nomeDoDeclarado(pendente.rotulo ?? ''),
  };
}

export function textoDoPendente(pendente: ArquivoPendenteData): string {
  if (pendente.codigo === 'carimbo_do_tempo' && pendente.rotulo) {
    return t.carimboDaCcb.replace('{rotulo}', pendente.rotulo);
  }
  if (pendente.codigo !== 'documento_declarado') return t.item[pendente.codigo];
  return t.item.documento_declarado.replace('{nome}', nomeDoDeclarado(pendente.rotulo ?? ''));
}
